'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = stringify;

function stringify(obj) {
  var brackets = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
  var sep = arguments.length <= 2 || arguments[2] === undefined ? '&' : arguments[2];
  var eql = arguments.length <= 3 || arguments[3] === undefined ? '=' : arguments[3];
  var wrap = arguments.length <= 4 || arguments[4] === undefined ? '' : arguments[4];

  return Object.keys(obj).map(function (key) {
    if (typeof obj[key] === 'object') {
      return stringify(obj[key], brackets, sep, eql, key);
    }

    var isArray = Object.prototype.toString.call(obj) === '[object Array]';
    var safeKey = undefined;

    if (isArray) {
      /* PHP expects query parameters of type array to have no key (ie. ...&duration[]=1&duration[]=2...)
      See http://php.net/manual/en/function.http-build-query.php for more details */
      if (brackets) {
        safeKey = wrap ? encodeURIComponent(wrap) + '[]' : encodeURIComponent(key);
      } else {
        safeKey = wrap ? '' + encodeURIComponent(wrap) : encodeURIComponent(key);
      }
    } else {
      safeKey = wrap ? encodeURIComponent(wrap) + '[' + encodeURIComponent(key) + ']' : encodeURIComponent(key);
    }

    return '' + safeKey + eql + encodeURIComponent(obj[key]);
  }).join(sep);
}

module.exports = exports['default'];